/**
 * Common Constants & Configuration
 * Reusable constants and configurations used across the application
 */

// Candidate Table Columns Configuration
export const CANDIDATE_TABLE_COLUMNS = [
  { label: "Sr No", key: "srNo", isSortable: false },
  { label: "Actions", key: "actions", isAction: true },
  { label: "Name", key: "name" },
  { label: "Resume", key: "resumeFile" },
  { label: "Status", key: "feedbackStatus" },
  { label: "Role", key: "role" },
  { label: "Experience", key: "experience" },
  { label: "Primary Skills", key: "primarySkills" },
  { label: "Secondary Skills", key: "secondarySkills" },
  { label: "Tech Stack", key: "techStack" },
  { label: "Available From", key: "availableFrom" },
  { label: "Remote", key: "remoteAvailable" },
  { label: "Work Type", key: "workType" },
  { label: "CTC", key: "c2c" },
  { label: "Expected CTC", key: "expectedCTC" },
  { label: "Freelance Rate", key: "freelanceRate" },
  { label: "Referrer Code", key: "referrerCode" },
  { label: "Source", key: "source" },
  { label: "Email", key: "email" },
  { label: "Phone", key: "phone" },
  { label: "Location", key: "location" },
//   { label: "Applied Date", key: "appliedDate" },
  { label: "Ready to Travel", key: "readyToTravel" }
  // { label: "Aadhar No", key: "aadharNo" }, // COMMENTED OUT - Aadhar No column disabled
  // { label: "Pan Card No", key: "pancardNo" } // COMMENTED OUT - Pan Card No column disabled
];

// Default Fallback Roles
export const DEFAULT_FALLBACK_ROLES = [
  { role_id: 3, role_name: 'RECRUITER' },
  { role_id: 2, role_name: 'HR' },
  { role_id: 1, role_name: 'ADMIN' }
];

// Filter Initial State
export const INITIAL_CANDIDATE_FILTERS = {
  name: "",
  role: "",
  location: "",
  skills: "",
  experience: "",
  workType: "",
  feedbackStatus: "",
  readyToTravel: "",
  remoteAvailable: "",
  source: "",
  // noticePeriod: "", // COMMENTED OUT - Notice period filter disabled
  availableFromStart: "",
  availableFromEnd: ""
};

// Pagination Settings
export const PAGINATION_SETTINGS = {
  DEFAULT_ITEMS_PER_PAGE: 10,
  AVAILABLE_ITEMS_PER_PAGE: [5, 10, 15, 20, 50],
  MAX_PAGES_TO_SHOW: 5
};

// Experience Range
export const EXPERIENCE_RANGE = {
  MIN: 0,
  MAX: 30
};
